<template>
  <div v-show="isActive" class="y-tab-pane">
    <slot></slot>
  </div>
</template>

<script setup>
import { computed, inject, onMounted, getCurrentInstance } from "vue";

const props = defineProps({
  label: { type: String, required: true }
});

const registerTab = inject("registerTab");
const activeIndex = inject("activeIndex");
const registeredTabs = inject("registeredTabs");

const instance = getCurrentInstance();

onMounted(() => {
  if (registerTab) {
    registerTab({
      label: props.label,
      uid: instance.uid
    });
  }
});

const isActive = computed(() => {
  const myIndex = registeredTabs.findIndex(t => t.uid === instance.uid);
  return myIndex !== -1 && myIndex === activeIndex.value;
});
</script>
